import { AxiosError } from 'axios';
import { usePlotArea } from 'recharts';

import MessageEmptyData from './MessageEmptyData';
import MessageFailing from './MessageFailing';
import MessageFetching from './MessageFetching';

interface MessagesProps {
  error: AxiosError | null;
  isFetching: boolean;
  isFailing: boolean;
  onRetry: () => void;
  isEmpty: boolean;
  emptyText?: string;
  showEmptyHelp?: boolean;
}

const Messages = ({ error, isFetching, isFailing, onRetry, isEmpty, emptyText, showEmptyHelp }: MessagesProps) => {
  // recharts v3 dropped the `displayName="Customized"` trick that used to inject the plot-area
  // rect into this component; read it from the chart context instead.
  const plotArea = usePlotArea();

  if ((!isFetching && !isFailing && !isEmpty) || !plotArea) {
    return null;
  }

  const { x, y, width, height } = plotArea;

  return (
    <foreignObject x={x} y={y} width={width} height={height}>
      {isFetching && <MessageFetching />}
      {isFailing && <MessageFailing error={error} onFetch={onRetry} />}
      {!isFetching && !isFailing && isEmpty && (
        <MessageEmptyData emptyText={emptyText} showEmptyHelp={showEmptyHelp || !!emptyText} />
      )}
    </foreignObject>
  );
};

export default Messages;
